/** @module SiteAdmin/CentricDrive/FreezeFile */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/widget/MessageDialog"

	], function(declare,lang,Controller,PostRequest,locale,MessageDialog) {

	return declare(Controller, {

		/**
		 * @Override
		 * Display DialogMessage to inform permissions was successfully changed
		 */
		onPublishResponse: function(response) {
			new MessageDialog({
				buttons: [MessageDialog.BUTTON_OK],
				materialIcon: MessageDialog.ICON_INFO,
				message: locale.resource("DriveFreezeDocument",[this.getNode()["File.File"]]),
				title: locale.resource("INFORMATION")
			}).show();
		},
		/**
		 * @Override
		 * Display Dialog Error Message to inform permissions were not changed
		 */
		_onError: function(response) {
			var displayMessage = locale.resource("DriveFailedFreezeDocument", [this.getNode()["File.File"]]);
			this.displayErrorDialog({message: displayMessage})
		},
		/**
		 * @Override
		 * Process PostRequest for freezing a document for all Users.
		 */
		process: function() {
			var req = this.m_action.m_request;
			var fd = this.m_formData;
			var req = new PostRequest(req.m_module, req.m_operation);
			req.addParameter("DocumentRevisionCNLId", this.getNode().$URL);
			this.waitForPublish(req.post({}), true);
		},
	});
});
